export let IMMEDIATELY_RB = 'immediately';
export let FUTURE_RB = 'future';
export let SALE_RB = 'sale';
export let SEARCH_CUSTOMER_RESULT = 'search-customer-result';
export let CUSTOMER_SEARCH_INPUT = 'customer_search_input';
export let SUBMIT = 'submit';
export const REPAIR_RB = 'repair_rb';
